import {Route, Switch} from 'react-router-dom';
import {getPageIndex} from 'src/EstateFlowchart/components/FormNav/FormNavUtils';
import {NavItem} from 'src/EstateFlowchart/components/FormNav/NavItem';
import FormPages from 'src/EstateFlowchart/config/FormPages';
import {FiduciarySummary, RevocableTrust} from 'src/EstateFlowchart/model/EstateFlowchartTypes';
import {IrrevocableTrust} from 'src/EstateFlowchart/model/IrrevocableTrust';
import {Will} from 'src/EstateFlowchart/model/Will';
import BasicInformationContent from 'src/EstateFlowchart/pages/BasicInformation/BasicInformationContent';
import React from 'react';
import {Miscellaneous} from "../../model/Miscellaneous";

type WillContentProps = {
    will: Will;
    pageConfig: NavItem[];
    updateWill: (will: Will) => void;
    fiduciaries: FiduciarySummary,
    updateFiduciaries: (fiduciarySummary: FiduciarySummary) => void;
}

function WillContent({
                         will,
                         pageConfig,
                         updateWill,
                         fiduciaries,
                         updateFiduciaries
                     }: Readonly<WillContentProps>) {
    return (
        <Switch>
            <Route
                path="/Profile/:id/ClientProfile/EstateFlowchart/:flowchartId/Will/:trustId/BasicInformation">
                <BasicInformationContent
                    basicInformation={will}
                    updateEstateItem={(estateItem: IrrevocableTrust | RevocableTrust | Will | Miscellaneous) => {
                        updateWill(estateItem as Will);
                    }}
                    formType="Will"
                    displayTrustDetails={false}
                    pageIndex={getPageIndex(pageConfig, FormPages.BASIC_INFORMATION.id)}
                    fiduciaries={fiduciaries}
                    updateFiduciaries={updateFiduciaries}
                />
            </Route>
        </Switch>
    )
}

export default WillContent